import script from "./ProjectTabAllocations.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectTabAllocations.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__